import { graphql } from '../../gql';

export const GET_PAYOUTS_QUERY = graphql(`
  query Payouts(
    $filter: String
    $first: Int
    $after: String
    $before: String
    $type: [TransactionType]
  ) {
    payoutConnection(
      filter: $filter
      first: $first
      after: $after
      before: $before
      type: $type
    ) {
      count
      edges {
        node {
          id
          idAlias
          payoutDate
          transaction {
            ... on PayoutTransactionStripe {
              transactionId
              to {
                bankName
                accountName
                last4Digits
                amount
                currencyCode
              }
            }
            ... on PayoutTransactionManual {
              reference
              to {
                type
                note
                amount
                currencyCode
              }
            }
          }
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`);
